<template>
  <div class="procureDailySupplier2">
    <h1>采购日汇总（到达）</h1>
    <el-form :inline="true">
      <el-form-item label="到货日期">
        <el-date-picker v-model="searchParam.receiveDates" type="daterange" start-placeholder="起" end-placeholder="止" style="width: 220px;" />
      </el-form-item>
      <el-form-item label="仓储">
        <el-select v-model="searchParam.storage" filterable style="width: 120px;" clearable>
          <el-option v-for='storageItem in show.storageList' :key="storageItem.id" :label="storageItem.value" :value="storageItem.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="供应商">
        <el-select v-model="searchParam.supplier" filterable style="width: 180px;" clearable>
          <el-option v-for="supplierItem in show.supplierList" :key="supplierItem.id" :label="supplierItem.value" :value="supplierItem.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-switch v-model="searchParam.hasStorage" active-text="区分仓储" />
      </el-form-item>
      <el-form-item label="">
        <el-switch v-model="searchParam.hasSupplier" active-text="区分供应商" />
      </el-form-item>
      <el-form-item label="">
        <el-switch v-model="searchParam.hasProduct" active-text="区分品名" />
      </el-form-item>
      <el-form-item label="">
        <el-switch v-model="searchParam.hasSendProductPrice" active-text="区分煤矿单价" />
      </el-form-item>
      <el-form-item label="">
        <el-switch v-model="searchParam.hasSendTransportPrice" active-text="区分运费单价" />
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="commitFindList()">搜索</el-button>
          <el-button @click="resetSearchParam()">重置</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-text type="danger">* 按照</el-text>
        <el-text type="danger" v-if="searchParam.hasStorage" style="margin: 0 5px;">仓储</el-text>
        <el-text type="danger" v-if="searchParam.hasSupplier" style="margin: 0 5px;">供应商</el-text>
        <el-text type="danger" v-if="searchParam.hasProduct" style="margin: 0 5px;">品名</el-text>
        <el-text type="danger" v-if="searchParam.hasSendProductPrice" style="margin: 0 5px;">原单价</el-text>
        <el-text type="danger" v-if="searchParam.hasSendTransportPrice" style="margin: 0 5px;">原运费单价</el-text>
        <el-text type="danger">不同统计车数和数量</el-text>
      </el-form-item>
      <el-form-item>
        <el-button-group>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="data.list" @selection-change="selectionChange()" ref="tabRef" border style="height: calc(100vh - 310px);" show-summary :summary-method="summary">
      <el-table-column prop="storage" label="仓储" show-overflow-tooltip v-if="show.tableStorage" />
      <el-table-column prop="supplier" label="供应商" show-overflow-tooltip v-if="show.tableSupplier" />
      <el-table-column prop="product" label="煤矿品名" show-overflow-tooltip v-if="show.tableProduct" />
      <el-table-column prop="truckQuantity" label="车数" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ scope.row.truckQuantity }}
        </template>
      </el-table-column>
      <el-table-column prop="receiveQuantity" label="到货数量" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.receiveQuantity) }}
        </template>
      </el-table-column>
      <el-table-column prop="receiveProductPrice" label="煤矿单价" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.receiveProductPrice) }}
        </template>
      </el-table-column>
      <el-table-column prop="receiveTransportPrice" label="运费单价" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.receiveTransportPrice) }}
        </template>
      </el-table-column>
    </el-table>
    <div style="height: 10px;" />
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'
import api from '../../apis/api'
import util from '../../utils/util'
import math from '../../utils/math'

const tabRef = ref()

const data = reactive({
  list: [],
  summary: {},
})

const show = reactive({
  tableStorage: true,
  tableSupplier: true,
  selected: [],
  supplierList: [],
  storageList: [],
})

api.get('/backend/dict/getByCode', { params: { code: 'supplier' } }).then(res => {
  show.supplierList = res.dictList
})
api.get('/backend/dict/getByCode', { params: { code: 'storage' } }).then(res => {
  show.storageList = res.dictList
})

const now = new Date()
const yesterday = new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000)
const searchParam = reactive({})
const resetSearchParam = () => {
  searchParam.receiveDates = [yesterday, yesterday]
  searchParam.hasStorage = false
  searchParam.hasSupplier = false
  searchParam.hasProduct = false
  searchParam.hasSendProductPrice = true
  searchParam.hasSendTransportPrice = true
  searchParam.supplier = null
  searchParam.storage = null
}
resetSearchParam()

const commitFindList = () => {
  const params = JSON.parse(JSON.stringify(searchParam))
  if (searchParam.receiveDates && searchParam.receiveDates.length == 2) {
    params.receiveDateGe = util.parseTime(searchParam.receiveDates[0], '{y}-{m}-{d}')
    params.receiveDateLe = util.parseTime(searchParam.receiveDates[1], '{y}-{m}-{d}')
  }
  params.supplier = searchParam.supplier
  params.storage = searchParam.storage
  show.tableStorage = params.hasStorage
  show.tableSupplier = params.hasSupplier
  show.tableProduct = params.hasProduct
  api.post('/backend/procure/getDaily', params).then(res => {
    data.list = res.list
    data.summary = res.summary
  })
}

const selectionChange = () => {
  show.selected = tabRef.value.getSelectionRows()
}

const summary = () => {
  const result = []
  if (show.tableStorage) {
    result.push('')
  }
  if (show.tableSupplier) {
    result.push('')
  }
  if (show.tableProduct) {
    result.push('')
  }
  result.push(
    data.summary.truckQuantity,
    math.formatNumber(data.summary.receiveQuantity),
    math.formatNumber(data.summary.receiveProductPrice),
    math.formatNumber(data.summary.receiveTransportPrice)
  )
  return result
}
</script>

<style lang="less"></style>